import { createSlice } from '@reduxjs/toolkit'
import { fetchProfile } from '../thunk/userThunk'
import { DINING_METHOD_OPTIONS } from '@common'
import { storageHelpers } from '@utils'

const storedProfile = storageHelpers.getUserProfile()
const initialProfile = storedProfile === 'undefined' ? null : storedProfile || null

const initialState = {
    // status
    isLoading: false,
    error: null,

    // data
    profile: initialProfile,
    diningMethod: DINING_METHOD_OPTIONS[0],
    tableId: null,
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        clearUser: state => {
            state.profile = null
            storageHelpers.clearUserProfile()
        },
        setProfile: (state, action) => {
            state.profile = action.payload
            if (action.payload) storageHelpers.setUserProfile(action.payload)
        },
        setDiningMethod: (state, action) => {
            state.diningMethod = action.payload
        },
        setTableId: (state, action) => {
            state.tableId = action.payload
        },
    },
    extraReducers: builder => {
        builder
            /** fetchProfile */
            .addCase(fetchProfile.pending, state => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchProfile.fulfilled, (state, action) => {
                state.isLoading = false
                state.profile = action.payload

                if (action.payload) storageHelpers.setProfile(action.payload)
            })
            .addCase(fetchProfile.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
            })
    },
})

export const userActions = {
    ...userSlice.actions,
    fetchProfile,
}

export default userSlice.reducer
